// AI assisted development

import { ContextInfo } from '../../@shared/models/context-info';
import {
  PendoInitializeAccount,
  PendoInitializePayload,
  PendoInitializeVisitor,
} from '../models/pendo-visitor-schema';
import {
  PENDO_APPLICATION,
  PENDO_EXCLUDED_VISITOR_FIELDS,
} from './pendo.config';

function isNonEmpty(value: any): boolean {
  return value !== undefined && value !== null && String(value).trim() !== '';
}

function omitExcluded(payload: { [key: string]: any }): void {
  for (let i = 0; i < PENDO_EXCLUDED_VISITOR_FIELDS.length; i++) {
    const field = PENDO_EXCLUDED_VISITOR_FIELDS[i];
    if (Object.prototype.hasOwnProperty.call(payload, field)) {
      delete payload[field];
    }
  }
}

/** Maps ContextInfo account fields; omits account when clientId is missing. */
export function toPendoAccount(context: ContextInfo): PendoInitializeAccount | null {
  if (context == null || context.clientId === undefined || context.clientId === null) {
    return null;
  }
  const account: PendoInitializeAccount = {
    id: String(context.clientId),
    AccountId: String(context.clientId),
  };
  omitExcluded(account);
  return account;
}

/**
 * Maps ContextInfo to a pendo.initialize payload using the UP-54793 allowlist.
 * visitor.id is userId (cross-app identity). shopperkit_application is set on visitor.
 */
export function toPendoInitializePayload(context: ContextInfo, language: string): PendoInitializePayload {
  const visitor: PendoInitializeVisitor = {
    id: context && context.userId ? String(context.userId) : '',
  };
  visitor.shopperkit_application = PENDO_APPLICATION;

  if (context) {
    if (isNonEmpty(context.fullName)) {
      visitor.Full_Name = context.fullName;
    }
    if (isNonEmpty(context.email)) {
      visitor.Email = context.email;
    }
    if (isNonEmpty(context.userName)) {
      visitor.Username = context.userName;
    }
  }
  if (isNonEmpty(language)) {
    visitor.AppSetLanguage = language;
  }

  omitExcluded(visitor);

  const payload: PendoInitializePayload = { visitor: visitor };
  const account = toPendoAccount(context);
  if (account) {
    payload.account = account;
  }
  return payload;
}
